import { yup } from 'common/validation/initYup';
import { ValidationSchema } from 'common/validation/ValidationSchema';
import { Type, Transform, plainToClass, classToPlain } from 'class-transformer';
import { TypeTransformDecimal } from 'common/dto/shared/types/TypeTransformDecimal';
import { Decimal } from 'decimal.js-light';
import { ApiProperty } from '@nestjs/swagger';
import type { IDto, IDtoPartial } from 'common/dto/shared/DtoInterfaces';
import { GenerateDto } from "cli/generate/decorators/GenerateDecorators";
import { SchemaLabel } from "cli/generate/decorators/SchemaDecorators";



@GenerateDto()
class ContractSendRegistered {
    @SchemaLabel('con Scheda Anagrafica')
    withCard!: boolean;
}

/**
 * Rappresentazione DTO della classe ContractSendRegistered 
 * Hash: cc08809ded4a6e990f4ac1fc18e7f55d
 */
@ValidationSchema(() => ContractSendRegisteredSchema)
export class ContractSendRegisteredDto {
  @ApiProperty({ type: Boolean, description: 'con Scheda Anagrafica' })
  withCard!: boolean;

  /** Proprietà che identifica i DTO */
  readonly __dto!: any;

  /**
   * Crea una nuova istanza con i valori forniti
   */
  constructor(values?: IDtoPartial<ContractSendRegisteredDto>) {
    if (values != null) {
      Object.assign(this, values instanceof ContractSendRegisteredDto ? values : plainToClass(ContractSendRegisteredDto, values));
    }
  }

  async validate(options?: any) {
    const validated = await ContractSendRegisteredSchema.validate(classToPlain(this), options);
    return new ContractSendRegisteredDto(validated);
  }
}

export const ContractSendRegisteredSchema = yup
  .object({
    withCard: yup.boolean().required().label('con Scheda Anagrafica')
  })
  .noUnknown()
  .meta({ schemaName: "ContractSendRegisteredSchema" })
  .required();
